import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledDatabaseEntityProfileFoldout
  from 'components/organisms/Foldouts/DatabaseEntityProfileFoldout/DatabaseEntityProfileFoldout.styles';

const DatabaseEntityProfileFoldout = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DatabaseEntityProfileFoldout');

  return <StyledDatabaseEntityProfileFoldout ref={ref} {...innerProps} />
});

DatabaseEntityProfileFoldout.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DatabaseEntityProfileFoldout;
